import React, { useEffect, useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  NavLink as TabLink,
  FormGroup,
  BreadcrumbItem,
  Breadcrumb,
} from "reactstrap";

// images
import upload from "../../../assets/image/icons/upload.svg";
import { directUrl } from "../../../helpers/Constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Triangle } from "react-loader-spinner";
import { userStore } from "../../../stores";
import axios from "axios";
import { API_URL } from "../../../config";
import FileSaver from "file-saver";
import xls from "../../../assets/ayan12.xls";
function UploadReport() {
  let [filetxt, setFiletxt] = useState("Choose File");
  let [browseremove, setBrowseremove] = useState("Browse");
  const [fileData, setFileData] = useState([]);
  let [loading, setLoading] = useState(false);
  const [imageData, setImageData] = useState([]);
  let [formErrors, setFormErrors] = useState({});
  const navigate = useNavigate();

  const onFileChange = (event) => {
    setFileData(event.target.files[0]);
  };
  const successToast = (message) =>
    toast.success(message, {
      position: "bottom-right",
    });

  const errorToast = (error) =>
    toast.error(error, {
      position: "bottom-right",
    });

  const file_select = (e) => {
    onFileChange(e);
    if (e.target.files[0] == null) {
      setFiletxt("Choose File");
      setBrowseremove("Browse");
    } else {
      setImageData(e.target.files[0]);
      const filepath = e.target.files[0].name;
      setFiletxt(filepath);
      setBrowseremove("Choose Again");
    }
  };
  const validateBanner = async (e) => {
    e.preventDefault();
    const validate = formValidation();
    setFormErrors(validate);
    console.log("validate", validate);
    if (Object.keys(validate).length == 0) {
      submitForm(e);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("file", imageData);
    formData.append("filename", imageData.name);
    console.log(formData, "---->", imageData);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: userStore.token || "",
      },
    };

    try {
      const data = await axios.post(
        `${API_URL}/report/uploadReport`,
        formData,
        config,
        {
          body: JSON.stringify({
            formData,
          }),
        }
      );
      if (data.data.statusCode === 200) {
        setLoading(false);
        successToast("Successfully created company");
        navigate(`${directUrl}auditor/reports`);
      }
      console.log("first", data);
      if (data.data.statusCode === 401) {
        console.log("first", data);
        setLoading(false);
        errorToast(data.data.message);
      }
      if (data.data.statusCode === 500) {
        console.log("first", data);
        setLoading(false);
        errorToast("Check excel uploaded is in proper format");
      }
      setLoading(false);
    } catch (error_1) {
      setLoading(false);
      errorToast(error_1.message);
      console.log(error_1);
    }
  };

  const formValidation = () => {
    const errors = {};
    console.log(imageData.name);
    let fileExt = imageData.name.split(".");
    fileExt = fileExt[fileExt.length - 1];
    console.log(fileExt);
    if (imageData.length == 0) {
      errors.file = "File is required";
      errorToast("File is required");
    } else if (fileExt != "xls" && fileExt != "xlsx") {
      errors.file = "File should be XLS or XLSX";
      errorToast("File should be XLS or XLSX");
    }

    return errors;
  };
  return (
    <main>
      <section className="lyt-section ">
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : null}

        <Container fluid className="typ-container">
          <div className="breadcrumb-row">
            <Breadcrumb className="bs-breadcrumb mt-0">
              <BreadcrumbItem>
                <NavLink to={`${directUrl}auditor/reports`}>Report</NavLink>
              </BreadcrumbItem>
              <BreadcrumbItem active>Upload Report</BreadcrumbItem>
            </Breadcrumb>
            <button
              className="bs-btn typ-white"
              onClick={() => {
                FileSaver.saveAs(xls, "Sample-Report.xls");
              }}
            >
              {" "}
              <span class="icon icon-plus"></span> Sample Template{" "}
            </button>
          </div>
          <div className="bs-card">
            <Row>
              <div className="selector">
                <img className="upload_img" src={upload} />
                <FormGroup className="text-center">
                  <div className="selector-text">
                    <h3 className="dynamic-message">
                      {" "}
                      <span className="browse-files-text">{filetxt}</span>{" "}
                      <span className="browse-files-text" id="browsetxt">
                        {browseremove}
                      </span>
                      <input
                        type="file"
                        id="fileinput"
                        className="default-file-input"
                        onChange={file_select}
                      />{" "}
                    </h3>
                    <label className="text-label">
                      {" "}
                      Supported format: Excel{" "}
                    </label>
                  </div>
                  <button
                    className="bs-btn btn-submit"
                    type="button"
                    onClick={(e) => validateBanner(e)}
                  >
                    SUBMIT
                  </button>
                </FormGroup>
              </div>
            </Row>
          </div>
        </Container>
        <ToastContainer />
      </section>
    </main>
  );
}

export default UploadReport;
